module.exports = __webpack_public_path__ + "img/zh-cn.63d79d85.svg";